export default __webpack_public_path__ + "6af53a479ff710279661bb61a3e5bc3a.png";